import { render, staticRenderFns } from "./CollectionFolder.vue?vue&type=template&id=f174d934&lang=pug&"
import script from "./CollectionFolder.vue?vue&type=script&lang=js&"
export * from "./CollectionFolder.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports